// extracted by mini-css-extract-plugin
module.exports = {"dialogWrapperRoot":"_10NI_82N8Vc_BZgSCUckF4","paperFullScreen":"_1UCq7omUEEn_7plLTLHsB"};